export { HeartFilledIcon } from './heart-filled'
